import { render, staticRenderFns } from "./tab2-wages.vue?vue&type=template&id=0cf9e95a&scoped=true&"
import script from "./tab2-wages.vue?vue&type=script&lang=js&"
export * from "./tab2-wages.vue?vue&type=script&lang=js&"
import style0 from "./tab2-wages.vue?vue&type=style&index=0&id=0cf9e95a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cf9e95a",
  null
  
)

export default component.exports